import { useQuery } from '@tanstack/react-query';
import { placesApi } from '@/features/places/api/placesApi';
import { Place } from '@/types/place';

/**
 * Custom hook for fetching place details by ID using TanStack Query.
 */
export const usePlaceDetails = (placeId: string | undefined) => {
  const { data, isLoading, isError, error, refetch } = useQuery<Place>({
    queryKey: ['place', placeId],
    queryFn: () => placesApi.getById(placeId!),
    enabled: !!placeId, // Only run query if placeId is defined
    retry: 1,
  });

  return {
    place: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
